import React, { createContext, useContext } from 'react';
import { ToastContainer, useToast, toast as toastHelpers, type ToastProps } from '@components/ui/Toast';

interface ToastContextType {
  addToast: (toast: Omit<ToastProps, 'id'>) => string;
  removeToast: (id: string) => void;
  clearAllToasts: () => void;
  toast: typeof toastHelpers;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { toasts, addToast, removeToast, clearAllToasts, actuallyRemoveToast } = useToast();

  const value: ToastContextType = {
    addToast,
    removeToast,
    clearAllToasts,
    toast: toastHelpers,
  };

  return (
    <ToastContext.Provider value={value}>
      {children}
      <ToastContainer
        toasts={toasts}
        onRemoveToast={actuallyRemoveToast}
        position="top-right"
      />
    </ToastContext.Provider>
  );
};

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToastContext must be used within ToastProvider');
  }
  return context;
};
